import { render, staticRenderFns } from "./BaseErrorMessage.vue?vue&type=template&id=485f225f&"
import script from "./BaseErrorMessage.vue?vue&type=script&lang=js&"
export * from "./BaseErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports